  
const swiper = new Swiper('.swiper', {
  // 基本設定
  loop: true,
  effect: 'fade',
  speed: 800,
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
  },
  fadeEffect: {
    crossFade: true,
  }
});


const swiper1 = new Swiper('.sommelier-swiper', {
  speed: 600,
  slidesPerView: 3.8,
  //slidesPerGroup: 1,
  spaceBetween: 16,
  breakpoints: {
    0:   { slidesPerView: 1.2, spaceBetween: 12 },
    480: { slidesPerView: 2.2, spaceBetween: 12 },
    768: { slidesPerView: 3.2, spaceBetween: 14 },
    1024:{ slidesPerView: 3.8, spaceBetween: 16 },
  },
  //slideToClickedSlide: true,
  //mousewheel: true,
  loop: false,
  navigation: {
    nextEl: '.cards-next',
    prevEl: '.cards-prev',
  },
});
  

    